var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import getByPath from 'lodash/get';

/**
 * Helper function to get values using currency and timespan
 */
export var getValues = function getValues(values, currency, timespan) {
  values = getByPath(values, '[' + (currency || '').toUpperCase() + ']') || values;
  return (Array.isArray(values) ? values : []).filter(function (v) {
    return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v.timespan === timespan || typeof v === 'number';
  }).map(function (v) {
    return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? v.amount : v;
  });
};

export var convertTimeValues = function convertTimeValues(value, valueType) {
  var convertedAmounts = {};

  var minutes = valueType === 'hours' ? value * 60 : valueType === 'days' ? value * 24 * 60 : valueType === 'weeks' ? value * 24 * 7 * 60 : valueType === 'months' ? value * 24 * 30 * 60 : valueType === 'years' ? value * 24 * 365 * 60 : value;

  var years = Math.floor(minutes / 525600);
  var months = Math.floor(minutes % 525600 / 43200);
  var weeks = Math.floor(minutes % 525600 % 43200 / 10080);
  var days = Math.floor(minutes % 525600 % 43200 % 10080 / 1440);
  var hours = Math.floor(minutes % 525600 % 43200 % 10080 % 1440 / 60);
  minutes = Math.floor(minutes % 525600 % 43200 % 10080 % 1440 % 60);

  convertedAmounts = {
    years: years,
    months: months,
    weeks: weeks,
    days: days,
    hours: hours,
    minutes: minutes
  };

  return convertedAmounts;
};